<template>
	<template v-if="['administrator'].includes(getUserRole)">
		<button class="btn btn--color" @click="ShowAddEditManagerPopup = !ShowAddEditManagerPopup">Добавить менеджера</button>

		<transition name="modal">
			<AddEditManagersPopup :productGroups="productGroups" v-if="ShowAddEditManagerPopup" @close="ShowAddEditManagerPopup = false" />
		</transition>
	</template>
</template>
<script>
import AddEditManagersPopup from "@/components/sections/Managers/AddEditManagersPopup.vue";
import {mapGetters} from "vuex";

export default {
	name: "ManagersAdd",
	components: {AddEditManagersPopup},
	props: {
		productGroups: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			ShowAddEditManagerPopup: false
		}
	},
	computed: {
		...mapGetters({
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


